module.exports = __webpack_public_path__ + "static/media/tea_herbal.8d2a8c9b.svg";